import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from 'rebass';
import { useHistory, useParams } from 'react-router-dom';

import Modal from 'app/modal/v3';
import Button from 'app/buttons';
import { useFamilyTreeSWR, destroyFamilyMember } from './api';
import { parseFamilyTree, memberFullName } from './helpers';

// Confirm + unlink a family member (DELETE /family_members/:id).
const DeleteMemberModal = ({ journalId, baseRoute }) => {
  const { replace } = useHistory();
  const { memberId } = useParams();
  const { data, revalidate } = useFamilyTreeSWR(journalId);
  const { members } = parseFamilyTree(data);
  const member = members.find((m) => m.id === memberId);
  const name = memberFullName(member) || 'this profile';

  const [loading, setLoading] = useState(false);
  const close = () => replace(`${baseRoute}/members/${memberId}/edit`);

  const onConfirm = async () => {
    setLoading(true);
    try {
      await destroyFamilyMember(journalId, memberId);
      revalidate();
      replace(`${baseRoute}?added=removed`);
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <Modal close={{ onClose: close }} noHeader>
      <Flex flexDirection="column" alignItems="center" textAlign="center" px={4} py={4}>
        <Box
          fontSize="48px"
          mb={2}
          role="img"
          aria-label="squirrel"
        >
          🐿️
        </Box>
        <Text
          fontFamily="Bitter"
          fontWeight={500}
          fontSize="20px"
          color="defaultText"
          mb={4}
        >
          {`Are you sure you want to delete ${name}?`}
        </Text>
        <Flex sx={{ gap: '12px' }}>
          <Button type="button" muted pill onClick={close}>
            Cancel
          </Button>
          <Button type="button" destructive pill loading={loading} onClick={onConfirm}>
            Delete
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

DeleteMemberModal.propTypes = {
  journalId: PropTypes.string.isRequired,
  baseRoute: PropTypes.string.isRequired,
};

export default DeleteMemberModal;
